var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.filterCssClasses},[_c('button',{staticClass:"filter-button reset-button-style",on:{"click":function($event){return _vm.$emit('filter-click', _vm.value)}}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }